import {createStyles} from '@material-ui/core';

export const style = () =>
  createStyles({
    indicator: {
      borderRadius: '16px',
      padding: '4px 12px',
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: 500,
      textAlign: 'center',
      backgroundColor: 'transparent',
    },
  });
